<div>
	<div class="r6-map-overview-stats-widget">
		<div class="stats-title">
			<h4>Campaign Data</h4>
			<app-printable-report-r1 overviewprintablereport="overview" *ngIf="overviewReport"></app-printable-report-r1>
			<app-product-csv-download overviewCsvKey="true" [hasTooltip]="true"></app-product-csv-download>
		</div>
		<table
			class="ovw-table"
			*ngIf="hasData"
			[ngClass]="!youtubeViewsPermission ? 'ovw-tbl-no-youtube' : 'ovw-tbl-youtube'"
		>
			<tr class="ovw-header">
				<th class="first-title">Product</th>
				<th class="imprs-th">Imprs</th>
				<th>Clicks</th>
				<th>CTR</th>
			</tr>
			<tr
				*ngFor="let overviewStat of overviewStats; let last = last"
				class="ovw-tr"
				[ngClass]="{
					'disabled-product': overviewStat.isDisabled,
					'zero-imprs': !hasAnyData(overviewStat),
					hasimpressiondata: hasAnyData(overviewStat)
				}"
			>
				<td data-th="Product">
					<div
						class="prod-div checked-div {{ overviewStat.productName }}"
						*ngIf="!isGamSeperated_R || overviewStat.productKey !== 'gam' || hasGamMapAccess"
					>
						<span *ngIf="!overviewStat.isDisabled">
							<img
								src="../../../../../assets/images/check.png"
								class="product-enabled"
								(click)="productSelection(overviewStat)"
								*ngIf="overviewStat.productSelected"
							/>
							<img
								src="../../../../../assets/images/uncheck.png"
								class="product-enabled"
								(click)="productSelection(overviewStat)"
								*ngIf="!overviewStat.productSelected"
							/>
						</span>
					</div>
					<div class="prod-div" [ngClass]="{ 'has-gam-map-access': hasGamMapAccess }">
						<label class="product-title {{ overviewStat.productName }}">{{ overviewStat.productName }}</label>
					</div>
				</td>
				<td
					data-th="Total Imprs"
					*ngIf="!overviewStat.isEmail"
					class="lora-font"
					[ngClass]="{ 'disabled-td': overviewStat.isDisabled || !overviewStat.productSelected }"
				>
					{{ overviewStat.impressions | formatNumber }}
				</td>
				<td
					data-th="Total Imprs"
					*ngIf="overviewStat.isEmail"
					class="lora-font"
					[ngClass]="{ 'disabled-td': overviewStat.isDisabled || !overviewStat.productSelected }"
				>
					<span>N/A</span>
				</td>
				<td
					data-th="Total Clicks"
					class="lora-font"
					[ngClass]="{ 'disabled-td': overviewStat.isDisabled || !overviewStat.productSelected }"
				>
					<span *ngIf="overviewStat.hasClicks; else naBlock1">{{ overviewStat.clicks | formatNumber }}</span>
					<ng-template #naBlock1>
						<span>N/A</span>
					</ng-template>
				</td>
				<td
					data-th="CTR"
					*ngIf="!overviewStat.isEmail"
					class="lora-font"
					[ngClass]="{ 'disabled-td': overviewStat.isDisabled || !overviewStat.productSelected }"
				>
					<span *ngIf="overviewStat.hasCtr; else naBlock2">{{ overviewStat.ctr | number : '1.2-2' }} %</span>
					<ng-template #naBlock2>
						<span>N/A</span>
					</ng-template>
				</td>
				<td
					data-th="CTR"
					*ngIf="overviewStat.isEmail"
					class="lora-font"
					[ngClass]="{ 'disabled-td': overviewStat.isDisabled || !overviewStat.productSelected }"
				>
					<span>N/A</span>
				</td>
			</tr>
		</table>
		<table class="ovw-table-youtube" *ngIf="hasData && youtubeViewsPermission && isR6">
			<tr class="ovw-header ovw-youtube-tr" *ngIf="youtubeViewsPermission && isR6">
				<th class="ovw-table-youtube-th">Product</th>
				<th class="ovw-table-youtube-th-2">youtube views</th>
				<th class="ovw-table-youtube-th" colspan="2">youtube view rate</th>
			</tr>
			<tr
				*ngFor="let overviewYoutubeStat of overviewYoutubeStats; let last = last"
				class="ovw-tr ovw-youtube-tr"
				[ngClass]="{
					'disabled-product': overviewYoutubeStat.isDisabled,
					'zero-imprs': isZeroImpression(overviewYoutubeStat.youtubeViews),
					hasimpressiondata: !isZeroImpression(overviewYoutubeStat.youtubeViews)
				}"
			>
				<td class="ovw-youtube-th" data-th="Product" *ngIf="youtubeViewsPermission && isR6">
					<div class="prod-div checked-div ovw-checkbox-div">
						<span *ngIf="!overviewYoutubeStat.isDisabled">
							<img
								src="../../../../../assets/images/check.png"
								class="product-enabled"
								(click)="productSelection(overviewYoutubeStat)"
								*ngIf="overviewYoutubeStat.productSelected"
							/>
							<img
								src="../../../../../assets/images/uncheck.png"
								class="product-enabled"
								(click)="productSelection(overviewYoutubeStat)"
								*ngIf="!overviewYoutubeStat.productSelected"
							/>
						</span>
					</div>

					<div class="prod-div">
						<label class="product-title">{{ overviewYoutubeStat.productName }}</label>
					</div>
				</td>
				<td
					data-th="YouTube Views"
					class="lora-font ovw-youtube-th"
					[ngClass]="{ 'disabled-td': overviewYoutubeStat.isDisabled || !overviewYoutubeStat.productSelected }"
					*ngIf="youtubeViewsPermission && isR6"
				>
					{{ overviewYoutubeStat.youtubeViews | formatNumber }}
				</td>
				<td
					data-th="YouTube View Rate"
					class="lora-font ovw-youtube-th"
					[ngClass]="{ 'disabled-td': overviewYoutubeStat.isDisabled || !overviewYoutubeStat.productSelected }"
					*ngIf="youtubeViewsPermission && isR6"
				>
					<span class="ovw-youtube-span" *ngIf="overviewYoutubeStat.youtubeViewRate; else naBlock"
						>{{ overviewYoutubeStat.youtubeViewRate | number : '1.2-2' }}%</span
					>
					<ng-template #naBlock>
						<span class="ovw-youtube-span">0.00%</span>
					</ng-template>
				</td>
			</tr>
			<!-- <tfoot>
              <td></td>
              <td>{{getTotalByColumn('impressions') | number}}</td>
              <td>{{getTotalByColumn('clicks') | number}}</td>
              <td>{{getTotalCTR() | percent:'1.2-2'}}</td>
          </tfoot> -->
		</table>
		<div class="map-data-disclaimer" style="display: none">
			<span class="disclaimer-text">*These products do not have map visualization available.</span>
		</div>
		<div class="no-data-container" *ngIf="!hasData">
			<div class="stats-title">
				<h4>Campaign Data</h4>
			</div>
			<div class="map-no-data no-data-text">No Data Available</div>
		</div>
	</div>
</div>
